import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  Field,
  DateTimeField,
  ContractEONType,
  ContractTypeBadgeField,
  CurrencyField,
  BooleanField,
  ResponsibleField,
} from '../../commons/DataTable';
import CustomerTypeField from '../../commons/DataTable/CustomerTypeField';
import AdminStateEnergyField from '../../commons/DataTable/AdminStateEnergyField';
import CurrencyFieldCentMc from '../../commons/DataTable/CurrencyFieldCentMc';
import CurrencyFieldInitialFixedValue from '../../commons/DataTable/CurrencyFieldInitialFixedValue';
import ModalAddDocument from './ModalAddDocument';
import CurrentAdminField from '../../commons/DataTable/CurrentAdminField';
import ManageDocument from './ManageDocument';
import { ENERGY_USERS_ADMIN } from '../../App';

function ContractsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  energyUser,
  profile,
  handleFileListView,
  handleDelete,
  onStatusChanged,
}) {
  const [t] = useTranslation('IAF_INVOICES');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="POD/PDR" source="pod_pdr" />
      <ContractTypeBadgeField title="Voce" source="partnerEonType" />
      <Field
        title="Partita iva detentore"
        source="currentAdminInfo.taxCode"
        visible={energyUser}
      />
      <CurrentAdminField
        title="Detentore"
        source="currentAdminInfo.name"
        visible={energyUser}
      />
      <ResponsibleField
        title="Intestatario"
        source="admin.name"
        visible={energyUser}
      />
      <Field
        title="P.Iva / Cod. fiscale fornitore"
        source="supplier.taxCode"
        visible={!energyUser}
      />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        visible={!energyUser}
      />
      <Field title="Nome cliente" source="condo_name" className="text-left" />
      <CustomerTypeField title="Tipologia Cliente" source="customerType" />
      <Field title="Partita IVA Cliente" source="condo_vat_cf" />
      <Field
        title="Referente ufficio"
        source="customerInfo.office.contactPerson"
        visible={profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ragione sociale ufficio"
        source="customerInfo.office.businessName"
        visible={profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ufficio"
        source="customerInfo.office.office"
        visible={profile.type === 'ASSOCIATION'}
      />
      <DateTimeField
        title="Data creazione"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data attivazione"
        source="activation_start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data Scadenza"
        source="contract_end_date"
        format="DD/MM/YYYY"
        hideForStorno
      />
      <DateTimeField
        title="Data Switch"
        source="selectedHistory.startDate"
        format="DD/MM/YYYY"
        hideForStorno
      />
      <Field
        title="Mensilità ricorrenze"
        source="recurringMonthlyPayment"
        hideForStorno
      />
      <AdminStateEnergyField
        title="Stato Gestione"
        visible={energyUser}
        hideForStorno
      />
      <Field
        title="Consumo da contratto iniziale"
        source="initial_contractual_consumption"
        hideForStorno
      />
      <Field
        title="Consumo da contratto"
        source="contractual_consumption"
        hideForStorno
      />
      <Field
        title="Consumo attuale"
        source="actual_consumption"
        hideForStorno
      />
      <ContractEONType
        title="Nome prodotto"
        source="product_name"
        hideForStorno
      />
      <CurrencyFieldInitialFixedValue
        title="Compenso fisso iniziale"
        source="energy_contract.initial_fixed_value"
        visible={energyUser}
        hideForStorno
      />
      <CurrencyFieldCentMc
        title="Fee iniziale a mc"
        visible={energyUser}
        hideForStorno
      />

      {(energyUser && (
        <CurrencyField title="Imponibile" source="contract_value" />
      )) ||
        (profile.type === 'ADMIN_COLLAB' && <></>) || (
          <CurrencyField
            title="Compenso Detentore Iniziali"
            source="adminShare"
            visible={profile.type !== 'UTILIZER'}
          />
        )}

      <CurrencyField
        title="Profitto Extra"
        source="extraShare"
        visible={profile.polis === true}
      />

      <CurrencyField
        title="Profitto Intestatario"
        source="adminShare"
        visible={profile.polis === true}
      />

      {(energyUser && (
        <CurrencyField
          title="Extra COMPENSO Ricorrenti"
          source="sumRecurringContracts"
          hideForStorno
        />
      )) ||
        (profile.type === 'ADMIN_COLLAB' && <></>) || (
          <CurrencyField
            title="Compenso Detentore Ricorrenti"
            source="sumRecurringContractsAdminShare"
            hideForStorno
            visible={profile.type !== 'UTILIZER'}
          />
        )}

      <BooleanField
        title="Abilitazione fattura"
        source="iafPolis"
        visible={profile.polis === true}
      />
      <DateTimeField
        title="Data abilitazione fattura"
        source="iaf_polis_date"
        format="DD/MM/YYYY"
        visible={profile.polis === true}
      />
      <ModalAddDocument
        title="Aggiungi documento"
        onStatusChanged={onStatusChanged}
        visible={profile.polis === true}
        hideForStorno
      />
      <ManageDocument
        title="Gestisci documento"
        handleFileListView={handleFileListView}
        handleDelete={handleDelete}
        hideForStorno
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profile.type)
        }
      />
      <ModalAddDocument
        title="Aggiungi report"
        onStatusChanged={onStatusChanged}
        visible={profile.polis === true}
        isReport={true}
        hideForStorno
      />
      <ManageDocument
        title="Gestisci report"
        handleFileListView={handleFileListView}
        handleDelete={handleDelete}
        isReport={true}
        hideForStorno
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profile.type)
        }
      />
    </DataTable>
  );
}

export default ContractsTable;
